export default "__VITE_ASSET__CpIsDwlf__"